import { render, staticRenderFns } from "./customerEditTabInformation.vue?vue&type=template&id=9b2b0a08&scoped=true&"
import script from "./customerEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./customerEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./customerEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2b0a08",
  null
  
)

export default component.exports